import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import ExamHeader from './components/ExamHeader/ExamHeader';
import ExamNavigation from './components/ExamNavigation/ExamNavigation';
import QuestionDisplay from './components/QuestionDisplay/QuestionDisplay';
import './previewTest.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getExamDetails } from '../../store/ExamSlice';
import store from '../../store/store';

const StudentPreviewTest = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const storeVar = useSelector(state => state.examDetails)
  const [activeSection, setActiveSection] = useState("");
  const [activeSectionId, setActiveSectionId] = useState("");
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [mockTestId, setMockTestId] = useState('');
  const [userId, setUserId] = useState('');


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get('mockTestId');
    const userId = params.get('userId');
    setMockTestId(id)
    setUserId(userId)
    dispatch(getExamDetails(id))
  }, [location.search]);
  useEffect(() => {
    if (storeVar.examData?.lessons?.length > 0) {
      setActiveSection(storeVar.examData.lessons[0].title);
      setActiveSectionId(storeVar.examData.lessons[0]._id);
    }
  }, [storeVar.examData]);

  // useEffect(() => {
  //   if (!storeVar.examData) return;

  //   if (storeVar.examData.isSwitchable) {
  //     if (storeVar.examData.duration) {
  //       setTimeRemaining(storeVar.examData.duration * 60);
  //     }
  //   } else {
  //     const activeLesson = storeVar.examData.lessons?.find(lesson => lesson._id === activeSectionId);
  //     if (activeLesson?.duration) {
  //       setTimeRemaining(activeLesson.duration * 60);
  //     }
  //   }
  // }, [storeVar.examData, activeSectionId]);

  useEffect(() => {
    if (!storeVar.examData) return;

    if (storeVar.examData.isSwitchable) {
      setTimeRemaining(storeVar.examData.duration * 60);
    }
  }, [storeVar.examData]);

  useEffect(() => {
    if (!storeVar.examData || storeVar.examData.isSwitchable) return;

    const activeLesson = storeVar.examData.lessons?.find(lesson => lesson._id === activeSectionId);
    if (activeLesson?.duration) {
      setTimeRemaining(activeLesson.duration * 60);
    }
  }, [activeSectionId, storeVar.examData]);



  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };


  const handleSectionChange = (section) => {
    if (!storeVar.examData?.isSwitchable) {
      // toast.warn("Section switching is disabled for this exam.");
      return;
    }
    setActiveSection(section.title);
    setActiveSectionId(section._id);
    // toast.success(`Switched to ${section.title} section`);
  };

  const handleNextSection = () => {
    const sections = storeVar.examData?.lessons || [];
    const currentIndex = sections.findIndex(sec => sec._id === activeSectionId);
    if (currentIndex === -1) return;

    if (currentIndex < sections.length - 1) {
      const nextSection = sections[currentIndex + 1];
      setActiveSection(nextSection.title);
      setActiveSectionId(nextSection._id);
      toast.info(`Moved to next section: ${nextSection.title}`);
    } else {
      toast.info("You have reached the last section.");
      // Optionally: submit test or disable further navigation
    }
  };


  return (
    <div className="exam-interface">
      <ExamHeader examTitle={storeVar?.examData && storeVar?.examData?.title} timeRemaining={formatTime(timeRemaining)} />
      <ExamNavigation sections={storeVar?.examData?.lessons} activeSection={activeSection} onSectionChange={handleSectionChange} />
      <QuestionDisplay lessonId={activeSectionId} activeSection={activeSection} onNextSection={handleNextSection} mockTestId={mockTestId} userId={userId}/>
    </div>
  )
}

export default StudentPreviewTest 